import { bannerApi } from 'entities/banner/model';
import { GetBannersQueryType, IBannerList } from 'entities/banner/types';
import { getBannersUrlConfig } from 'entities/banner/lib/helpers';

const getBannersApi = bannerApi.injectEndpoints({
  endpoints: (builder) => ({
    getBanners: builder.query<IBannerList, GetBannersQueryType>({
      query: (params) => getBannersUrlConfig(params),
      providesTags: ['Banners'],
    }),
    getBannerById: builder.query({
      query: ({ id }) => `/news-pages/admin/banner/${id}`,
      providesTags: ['BannerId'],
    }),
  }),
});

export const { useGetBannersQuery, useGetBannerByIdQuery } = getBannersApi;
